document.addEventListener("DOMContentLoaded", function () {
  const variantOptions = document.querySelectorAll("[data-variant-id]");
  const trioDiscoveryContainer = document.querySelector("[data-discovery-trio-images]");
  const octetDiscoveryContainer = document.querySelector("[data-discovery-octet-images]");
  const addToCartButton = document.querySelector("[data-add-to-cart-button]");
  let selectedVariants = [];
  let isTrioBundle = false; 
  let isOctetBundle = false; 

  function updateAddToCartButtonState() {
    let isEnabled = false;
    if (isTrioBundle && selectedVariants.length === 3) {
      isEnabled = true; 
    } else if (isOctetBundle && selectedVariants.length === 8) {
      isEnabled = true; 
    }
    addToCartButton.disabled = !isEnabled;
    addToCartButton.classList.toggle("opacity-50", !isEnabled);
    addToCartButton.classList.toggle("cursor-not-allowed", !isEnabled);
  }

  function updateDiscoveryContainer() {
    const container = isTrioBundle ? trioDiscoveryContainer : octetDiscoveryContainer;
    const imageDivs = container.querySelectorAll("[data-discovery-image-blank], [data-discovery-image-selected]");
    imageDivs.forEach(div => {
      div.setAttribute("data-discovery-image-selected", "false");
      div.setAttribute("data-discovery-image-blank", "true");
      div.innerHTML = "";
    });
    selectedVariants.forEach((variant, index) => {
      if (imageDivs[index]) {
        imageDivs[index].setAttribute("data-discovery-image-selected", "true");
        imageDivs[index].setAttribute("data-discovery-image-blank", "false");
        imageDivs[index].innerHTML = `<img src="${variant.src}" alt="Selected Variant Image" class="w-full h-auto rounded-md">`;
      }
    });
  }

  function detectBundleType() {
    if (trioDiscoveryContainer) {
      isTrioBundle = true;
    }
    if (octetDiscoveryContainer) {
      isOctetBundle = true;
    }
  }

  detectBundleType(); 
  variantOptions.forEach(option => {
    option.addEventListener("click", function (event) {
      if (event.target.closest("[data-variant-actions]")) return;
      const variantId = option.getAttribute("data-variant-id");
      const variantImageSrc = option.querySelector("[data-variant-image]").getAttribute("src");
      const variantTitle = option.getAttribute("data-variant-title") || "Unknown Variant";
      if (selectedVariants.some(variant => variant.id === variantId)) {
        selectedVariants = selectedVariants.filter(variant => variant.id !== variantId);
        option.removeAttribute("data-selected");
        option.classList.remove("discovery-variant__option--selected");
      } else if ((isTrioBundle && selectedVariants.length < 3) || (isOctetBundle && selectedVariants.length < 8)) {
        selectedVariants.push({ id: variantId, title: variantTitle, src: variantImageSrc });
        option.setAttribute("data-selected", "true");
        option.classList.add("discovery-variant__option--selected");
      }
      updateDiscoveryContainer();
      updateAddToCartButtonState();
    });
  });
  document.querySelectorAll("[data-variant-actions]").forEach(actionButton => {
    actionButton.addEventListener("click", function (event) {
      event.stopPropagation(); 
      const variantOption = actionButton.closest("[data-variant-id]"); 
      variantOption.classList.toggle("discovery-variant__option--active");
      const actionDefault = actionButton.querySelector("[data-variant-action-default]");
      const actionCancel = actionButton.querySelector("[data-variant-action-cancel]");
      if (actionDefault) {
        actionDefault.classList.toggle("discovery-variant__action-text--active");
      }
      if (actionCancel) {
        actionCancel.classList.toggle("discovery-variant__action-text--active");
      }
    });
  });

  function updateCartDrawerSection(cartQuantity, cartSubTotal) {
    fetch('/cart?id=right-drawer-slot')
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(html, 'text/html');
        
        const updatedSection = newDocument.querySelector('[data-cart-items]');
        const updatedFooter = newDocument.querySelector('[data-cart-footer]');
        const subTotal = document.querySelector("[cart-subtotal]");

        if (updatedSection) {
          document.querySelector('[data-cart-items]').innerHTML = updatedSection.innerHTML;
          document.querySelectorAll('[data-cart-mb] span, [data-cart-dekstop] span').forEach((item) => {
            item.textContent = `${cartQuantity}`;
          });
          document.querySelector('[data-cart-title] span').innerHTML = `${cartQuantity} ITEM`;

          if (updatedFooter) {
            document.querySelector('[data-cart-footer]').innerHTML = updatedFooter.innerHTML;
          }

          if (window.Alpine && Alpine.store) {
            Alpine.store('modals').open('cart');
          } else {
            console.error('Alpine.js or the store is not available.');
          }

          if (subTotal) {
            subTotal.innerHTML = "$" + cartSubTotal + " " + "USD";
          }
        }
      })
      .catch((error) => {
        console.error('Error updating the section:', error);
      });
  }
  function addSelectedVariantsToCart() {
    const mainProductId = document.querySelector("[data-variant-id]").getAttribute("data-variant-id");
    if (!mainProductId) {
      alert("Error: Main product variant ID not found. Please refresh the page and try again.");
      return;
    }
    if (!selectedVariants || selectedVariants.length === 0) {
      alert("Error: No variants selected for the bundle. Please select the variants and try again.");
      return;
    }
    const selectedVariantTitles = selectedVariants.map(variant => variant.title);
    const giftWrapCheckbox = document.querySelector("[data-gift-wrap]");
    const giftCardDropdown = document.querySelector("[data-gift-card]");
    const properties = {
      "Included Products": selectedVariantTitles.join(", "),
    };
    if (giftWrapCheckbox && giftWrapCheckbox.checked) {
      properties["Gift Wrap"] = `Yes`;
    }
    if (giftCardDropdown && giftCardDropdown.value !== "None") {
      properties["Gift Card"] = giftCardDropdown.value;
    }
    let formattedProperties = `${properties["Included Products"]}`;
    if (properties["Gift Wrap"]) {
      formattedProperties += ` / Gift Wrap: ${properties["Gift Wrap"]}`;
    }
    if (properties["Gift Card"]) {
      formattedProperties += ` / Gift Card: ${properties["Gift Card"]}`;
    }
    const data = {
      items: [
        {
          id: mainProductId,
          quantity: 1,
          properties: {
            Includes: formattedProperties,
          },
        },
      ],
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(cart => {
      if (window.Alpine && Alpine.store) {
        Alpine.store('modals').open('cart');
      } else {
        console.error('Alpine.js or the store is not available.');
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .catch(error => {
      console.error("Error adding item to cart:", error);
      alert(`Error: ${error.message}`);
    });
  }
  document.addEventListener('cart:updated', function () {
    updateHeaderCartCount();
    updateCartDrawerSection();
  });
  function updateHeaderCartCount() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('[data-header-cart-count]');
      const cartTitleElement = document.querySelector('[data-cart-title] span');
      const itemCount = cart.item_count || 0;
      cartCountElements.forEach(el => {
        el.textContent = itemCount;
      });
      if (cartTitleElement) {
        cartTitleElement.textContent = `${itemCount} ITEM${itemCount === 1 ? '' : 'S'}`;
      }
    })
    .catch(error => {
      console.error('Error fetching updated cart:', error);
    });
  }
  function updateCartDrawerSection() {
    fetch('/cart?id=right-drawer-slot')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');
      const updatedSection = newDocument.querySelector('[data-cart-items]');
      const updatedFooter = newDocument.querySelector('[data-cart-footer]');
      const subTotal = document.querySelector("[cart-subtotal]");
      if (updatedSection) {
        document.querySelector('[data-cart-items]').innerHTML = updatedSection.innerHTML;
      }
      if (updatedFooter) {
        document.querySelector('[data-cart-footer]').innerHTML = updatedFooter.innerHTML;
      }
      if (subTotal) {
        subTotal.innerHTML = "$" + (cart.items_subtotal_price / 100).toFixed(2) + " USD";
      }
    })
    .catch(error => {
      console.error('Error updating the cart drawer:', error);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateHeaderCartCount();
  });

  addToCartButton.addEventListener("click", (event)=>{
    event.preventDefault();
    addSelectedVariantsToCart();
  });
  updateAddToCartButtonState();
});

document.addEventListener('DOMContentLoaded', function() {
  let browserClass = '';
  if (navigator.userAgent.indexOf('Chrome') !== -1 && navigator.userAgent.indexOf('Edg') === -1) {
    browserClass = 'browser-chrome';
  } else if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
    browserClass = 'browser-safari';
  } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
    browserClass = 'browser-firefox';
  } else if (navigator.userAgent.indexOf('Edg') !== -1) {
    browserClass = 'browser-edge';
  } else if (navigator.userAgent.indexOf('Opera') !== -1 || navigator.userAgent.indexOf('OPR') !== -1) {
    browserClass = 'browser-opera';
  }
  if (browserClass) {
    document.body.classList.add(browserClass);
  }
});
